import { useStaticQueryDataChatMutuo } from "../query/useStaticQueryDataChatMutuo";
import Footer from "./Footer";
import MenuDesktop from "./MenuDesktop";
import ServiceBar from "./ServiceBar";
import loadable from "@loadable/component";
import classNames from "classnames";
import React, { useEffect } from "react";

const ConfrontoModalMutuo = loadable(() => import("./ConfrontoModalMutuo"));
const ChatMutuo = loadable(() => import("./ChatMutuo"));

const Layout = ({ children, data, location }) => {
  const isHpTemplate = data?.page?.template?.hp_template || false;
  const isHpTemplateLightVersion =
    data?.page?.template?.hp_template?.versioneLight || false;
  const isFullLayout = location?.state?.full || false;
  const isChatMutuoTemplate =
    data?.page?.template?.templateName === "ChatMutuo" || false;
  const isPageConfermaAppuntamenti =
    data?.page?.template?.templateName === "Conferma Appuntamenti" || false;

  const { chatMutuo } = useStaticQueryDataChatMutuo();

  const totalDisableChat = chatMutuo?.disattivazioneTotaleChatMutuo;
  const disableChat = data?.page?.disattivaChat?.disattiva_chat || false;
  return (
    <>
      {!isFullLayout && (
        <MenuDesktop
          isHpTemplate={isHpTemplate}
          isChatMutuoTemplate={isChatMutuoTemplate}
          ligthVersion={
            isHpTemplateLightVersion || isPageConfermaAppuntamenti || false
          }
        />
      )}
      <main
        className={classNames({
          main: !isFullLayout,
          "main-no-margin": isHpTemplate || isChatMutuoTemplate,
          "main-no-overflow chatmutuo": isChatMutuoTemplate,
        })}
      >
        {children}
      </main>
      {!isFullLayout && (
        <>
          <Footer />
          {!isPageConfermaAppuntamenti && (
            <ServiceBar
              isChatMutuoTemplate={isChatMutuoTemplate}
              isHpTemplateLightVersion={isHpTemplateLightVersion}
            />
          )}
          <ConfrontoModalMutuo />
          {totalDisableChat !== true &&
            !isChatMutuoTemplate &&
            !isPageConfermaAppuntamenti &&
            disableChat !== true && <ChatMutuo location={location} />}
        </>
      )}
    </>
  );
};

export default Layout;
